import { useConfigurationFinishedContext } from "../ConfigurationFinishedPage/ConfigurationFinishedContext";

import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { useRootCfgObject } from "@plansoft-configuration-renderer/framework";

import { iframeId, language } from "@/Router";
import { RegioluxArrowIcon } from "@/icons/RegioluxIcons";
import { useConfigurationServicePutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemId } from "@/openapi/api-cpq/queries/queries";
import { FloatingLoadingSpinner } from "@/tools/LoadingSpinner";

export default function SaveConfigurationButton({
  lineItemId,
}: {
  lineItemId: string | undefined;
}): JSX.Element {
  const { t } = useTranslation();
  const { isComplete } = useRootCfgObject();

  const { setIsConfigurationFinished } = useConfigurationFinishedContext();

  const { mutate: saveCfg, isPending } =
    useConfigurationServicePutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemId();

  const cfgSessionId = window.sessionStorage.getItem("cfgSessionId");
  const userSessionId = window.sessionStorage.getItem("userSessionId");

  const tooltipTitle = !isComplete
    ? t("regiolux:tooltip.configurationIncomplete")
    : !userSessionId
      ? t("regiolux:tooltip.noUserSessionId")
      : "";

  function saveConfiguration(): void {
    if (lineItemId && userSessionId && cfgSessionId)
      saveCfg(
        {
          lineItemId: lineItemId,
          requestBody: {
            userSessionId: userSessionId,
            configurationSessionId: cfgSessionId,
            localeId: language ? language : "de-DE",
          },
        },
        {
          onSuccess: () => {
            const postMessage = {
              iframeId: iframeId,
              eventName: "configurationComplete",
            };
            window.parent.postMessage(postMessage, "*");
            setIsConfigurationFinished(true);
          },
        },
      );
  }

  return (
    <>
      {isPending && <FloatingLoadingSpinner />}
      <Tooltip title={tooltipTitle}>
        <span>
          <Button
            disabled={!lineItemId || !isComplete}
            sx={{ marginTop: "1rem" }}
            onClick={saveConfiguration}
            endIcon={
              <RegioluxArrowIcon
                type="short"
                direction="right"
                style={{ fontSize: "0.8rem" }}
              />
            }
          >
            {t("regiolux:saveConfiguration")}
          </Button>
        </span>
      </Tooltip>
    </>
  );
}
